module.exports = __webpack_public_path__ + "img/pr-2.647574e2.png";